import React, { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";

const DesktopNav = () => {
  const searchTermRef = useRef();
  const navigate = useNavigate();

  const handleSearch = () => {
    console.log("Search term:", searchTermRef.current.value);
    if (searchTermRef.current.value && searchTermRef.current.value.trim()) {
      const search = searchTermRef.current.value.trim();
      searchTermRef.current.value = "";
      navigate(`/recipes?q=${encodeURIComponent(search)}`);
    }
  };

  return (
    <nav className="mx-auto flex items-center justify-between bg-slate-200 py-2">
      <Link to="/">
        <img
          src="/images/recipe_logo.svg"
          alt="logo"
          className="m-2 w-[250px] aspect-[2/0.25]"
        />
      </Link>
      <ul className="flex gap-5 space-x-5">
        <Link to="/">
          <li>Home</li>
        </Link>
        <Link to="/recipes">
          <li>Recipes</li>
        </Link>
        <div className="flex items-center">
          <input
            type="text"
            className="appearance-none bg-transparent border-none w-3/4 text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none"
            placeholder={"Search..."}
            ref={searchTermRef}
          />
          <CiSearch className="cursor-pointer" onClick={handleSearch} />
        </div>
      </ul>
    </nav>
  );
};

export default DesktopNav;
